/* This file is autogenerated, see readme.md for instructions */
import GridAltSvgIcon from '@bloomreach/banana-theme/icons/grid-alt.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const GridAltIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <GridAltSvgIcon />
    </Icon>
  );
});

GridAltIcon.displayName = 'GridAltIcon';

export default GridAltIcon;
